var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isYSOrder)?_c('ys-detail'):_c('default-detail')}
var staticRenderFns = []

export { render, staticRenderFns }